import React, { useState, useRef, useEffect, useCallback } from "react";
import { Card } from '@mui/material';
// import CalendarMain from "../Calendar/Calendar";
import TrainingDashboardFilter from "./TrainingDashboardFilter";
// import CustomCalendar from "../Calendar/CalendarCustom";
import ReactApexChart from 'react-apexcharts';
import RadialBarChart from "../Charts/RadialBarChart";
import BarChart from "../Charts/BarChart";
import BarAndPieChart from "../Charts/BarAndPieChart";
import SummaryGrid from "./SummaryGrid";
import Typography from '@mui/material/Typography';
import courseData from './mockData.json';
import DatePicker from "../Calendar/Calendar";
import AddTrainingForm from "./AddTrainingForm";
// import Year from '../Calendar/Year';

const Forecast = () => {
  const customChartRef = useRef();

  function formatNumber(value) {
    value /= 100;
    return Math.floor(value)
  }

  const [selectedYear, setSelectedYear] = useState();
  const [selectedYearInfo, setSelectedYearInfo] = useState();
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [datesArray, setDatesArray] = useState([]);
  const [selectedCustomerCode, setSelectedCustomerCode] = useState("Customer Code")
  const [selectedCustomerCodeInfo, setSelectedCustomerCodeInfo] = useState("Customer Code")
  const [showSummaryClick, setShowSummaryClick] = useState(false);

  const [barChartValues, setBarChartValues] = useState({
    data: ['05', '02', '07', '08'],
    categories: ["Product", "Software", "Operation", "Specific"]
  });

  const [pieChartValues, setPieChartValues] = useState({
    series: [5, 2, 7, 8],
    labels: ['Product', 'Software', 'Operation', 'Specific'],
    colors: ['#003CFF', '#00FFEE', '#146F9B', '#0090FF']
  });

  const [showTrainingForm, setShowTrainingForm] = useState(false);

  const trainingOptions = {
    series: [{
      data: ['06', '16'],
    },
    ],
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'horizontal',
        shadeIntensity: 0.5,
        gradientToColors: ['#2D9CDB', 'rgba(45, 156, 219, 0.2)'],
        inverseColors: true,
        opacityFrom: 0.5,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    chart: {
      height: 150,
      type: 'bar',
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        columnWidth: '45%',
        dataLabels: {
          position: 'top', // top, center, bottom
        },
      }
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ["#fff"]
      }
    },

    xaxis: {
      categories: ["Online", "Physical"],
      position: 'bottom',
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: '#fff',
        },
      },
      tooltip: {
        enabled: false,
      },
      crosshairs: {
        show: false,
      },
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
      }
    },
    title: {
      text: 'Training Mode',
      floating: true,
      offsetY: 330,
      align: 'left',
      style: {
        color: '#fff'
      }
    }
  }

  const handleBarClick = (event, chartContext, config) => {
    const data = courseData[barChartValues.categories[config.dataPointIndex].toLowerCase()];
    setPieChartValues({ series: data.value, labels: data.courseName, colors: data.colors })
  }

  const coursesOptions = {
    series: [{
      data: barChartValues.data,
    },
    ],
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'horizontal',
        shadeIntensity: 0.5,
        gradientToColors: ['#2D9CDB', 'rgba(45, 156, 219, 0.2)'],
        inverseColors: true,
        opacityFrom: 0.5,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    chart: {
      height: 150,
      type: 'bar',
      events: {
        dataPointSelection: handleBarClick
      },
      toolbar: {
        show: false,
      },
      //   sparkline: {
      //     enabled: true
      //  },
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        columnWidth: '45%',
        dataLabels: {
          position: 'top', // top, center, bottom
        },
      }
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ["#fff"]
      }
    },
    xaxis: {
      categories: barChartValues.categories,
      position: 'bottom',
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: '#fff',
        },
      },
      tooltip: {
        enabled: false,
      },
      crosshairs: {
        show: false,
      },
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
      }
    },
    title: {
      text: 'Course Taken',
      floating: true,
      offsetY: 330,
      align: 'left',
      style: {
        color: '#fff'
      }
    }
  }

  const legendFormatter = (seriesName, opts) => {
    const labelName = opts.w.config.label[opts.seriesIndex];
    const words = labelName.split(' ');
    let lines = [];
    let currentLine = '';
    for (let word of words) {
      if ((currentLine + word).length <= 12) {
        currentLine += word + ' '
      }
      else {
        lines.push(currentLine.trim());
        currentLine = word + '';
      }
    }
    lines.push(currentLine.trim());
    return lines.join('<br>')
    // return labelName.length > 10? labelName.substring(0,10) : labelName;
  }

  function getDoughnutData() {
    return [
      { type: 'Planned Days', count: 22 },
      { type: 'Forecast Days', count: 28 },
      { type: 'Actual Days', count: 18 },
    ];
  }

  const totalValues = (series) => {
    const total = series.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    return total;
  }

  const doughnutOptions = {
    series: [22, 26, 18],
    // fill: {
    colors: ['#7037B8', '#F4BC38', '#2D9CDB'],
    // },
    chart: {
      height: 400,
      width: 400,
      type: 'radialBar',
    },
    legend: {
      show: true,
      // floating:true,
      horizontalAlign: 'center',
      position: 'right',
      formatter: function (seriesName, opts) {
        return [opts.w.config.labels[opts.seriesIndex], '(' + opts.w.config.series[opts.seriesIndex] + ')']
      },
      labels: {
        colors: '#fff',
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 7,
          size: "30%",
        },
        track: {
          background: '#42414169',
          width: 400,
          margin: 10,
        },
        dataLabels: {
          name: {
            fontSize: '12px',
          },
          value: {
            fontSize: '12px',
            color: '#7037B8',
            formatter: function (val) {
              return val
            }
          },
          total: {
            show: true,
            fontSize: '12px',
            label: 'Planning',
            color: '#7037B8',
            formatter: function (w) {
              return w.globals.initialConfig.series[0]
            },
          },
        },
        colors: ['#7037B8', '#F4BC38', '#2D9CDB']
      },
    },
    labels: ['Planning', 'Forecasts', 'Actuals'],
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  const pieChartOptions = {
    series: pieChartValues.series,
    chart: {
      height: 400,
      width: 400,
      type: 'donut',
    },
    colors: pieChartValues.colors,
    label: pieChartValues.labels,
    tooltip: {
      enabled: false,
    },
    stroke: {
      colors: ['#2a2e32'],
      lineCap: 'round',
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            formatter: function (seriesName, opts) {
              return [opts.w.config.label[opts.seriesIndex]]
            },
            name: {
              fontSize: '10px',
            },
            value: {
              fontSize: '10px',
              color: '#fff',
            },
          }
        }
      }
    },
    legend: {
      show: true,
      position: 'right',
      formatter: function (seriesName, opts) {
        return legendFormatter(seriesName, opts)
      },
      labels: {
        colors: '#fff',
      },
      fontSize: '8px',
    },
    dataLabels: {
      enabled: true,
      // Set to true to show data labels
      style: {
        fontSize: '10px',
      },
      formatter: function (val, opts) {
        return opts.w.config.series[opts.seriesIndex]
      },
      total: {
        show: true,
        label: 'Total',
        color: 'white',
        formatter: function (w) {
          return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
        },
      },
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  const handleCustomerCodeChange = (custCode) => {
    setSelectedCustomerCodeInfo(custCode);
  }

  const handleYearChange = (year) => {
    setSelectedYear(year);
  }

  const handleCustomerCodeChangeInfo = (custCode) => {
    setSelectedCustomerCodeInfo(custCode);
  }

  const handleSummaryClick = () => {
    setShowSummaryClick(true);
  }

  const handleAddTraining = () => {
    setShowTrainingForm(true);
    setShowSummaryClick(true);
  }

  return (
    <>
      <div className="w-full sm:w-12/12 px-28">
        <TrainingDashboardFilter handleAddTraining={handleAddTraining} handleYearChange={handleYearChange} hideForecastButton={true} hideAddButton={false} handleSummaryClick={handleSummaryClick} handleCustomerCodeChange={handleCustomerCodeChange} />
      </div>
      {showSummaryClick ?
        <div className="flex p-24">
          <SummaryGrid />
        </div>
        :
        <div className="flex px-16">
          <div className="w-full sm:w-4/12 p-16">
            <Card
              className="relative flex flex-col flex-auto rounded-2xl shadow overflow-hidden items-center justify-center h-full"
            // sx={{ width: '100%', height: '250px' }}
            >
              <div className="text-left p-4">
                <Typography sx={{ fontSize: 14, textAlign: 'left', color: '#fff', fontWeight: 600 }} color="text.secondary" gutterBottom>
                  Progress Wheel YTD
                </Typography>
              </div>
              <div className="pr-12 pb-12">
                {/* <ReactApexChart options={doughnutOptions} series={doughnutOptions.series} type="radialBar" height={400} width={400} /> */}
                <RadialBarChart selectedYear={selectedYear} />
                {/* <CustomProgressWheel /> */}
              </div>
            </Card>
          </div>
          <div className="w-full sm:w-2/12 p-16">
            <Card
              className="relative flex flex-col flex-auto rounded-2xl shadow overflow-hidden items-center justify-center h-full"
            // sx={{ width: '100%', height: '250px' }}
            >
              <div className="text-left p-4">
                <Typography sx={{ fontSize: 14, textAlign: 'left', color: '#fff', fontWeight: 600 }} color="text.secondary" gutterBottom>
                  Training Mode
                </Typography>
              </div>
              <div className="p-10 pb-12">
                {/* <ReactApexChart options={trainingOptions} series={trainingOptions.series} type="bar" height={200} /> */}
                <BarChart selectedYear={selectedYear} />
              </div>
            </Card>
          </div>
          <div className="w-full sm:w-6/12 p-16">
            <Card
              className="relative flex-column flex-auto rounded-2xl shadow overflow-hidden items-center justify-center h-full"
            // sx={{ width: '100%', height: '250px' }}
            >
              <div className="text-center p-4">
                <Typography sx={{ fontSize: 14, color: '#fff', fontWeight: 600 }} color="text.secondary" gutterBottom>
                  Courses Taken
                </Typography>
              </div>
              <div className="flex">
                {/* <div className="pr-12 pb-12">
                <ReactApexChart options={coursesOptions} series={coursesOptions.series} type="bar" height={200} />
              </div>
              <div className="pr-12 pb-12">
                <ReactApexChart options={pieChartOptions} series={pieChartOptions.series} type="donut" height={400} width={300} />
              </div> */}
                <BarAndPieChart selectedYear={selectedYear} />
              </div>
            </Card>
          </div>
        </div>
      }
      <div style={{ borderTop: "1px solid #FFFFFF", margin: "20px 20px" }}></div>
      <div>
        <div className="w-full flex flex-column sm:w-12/12 px-16">
          <div className={`p-24 pr-12 sm:${showTrainingForm ? 'w-6/12' : 'w-12/12'} m-10 border-solid border-2 border-rose-400 rounded-3xl`}>
            {/* <CalendarMain /> */}
            {/* <CustomCalendar showTrainingForm={showTrainingForm}/> */}
            <DatePicker customerCode={selectedCustomerCodeInfo} selectedYear={selectedYear} setSelectedYear={setSelectedYearInfo} setSelectedDateRange={setSelectedDateRange} setDatesArray={setDatesArray} />
          </div>
          {showTrainingForm &&
            <div className="p-24 pr-12 w-6/12 m-10 border-solid border-2 border-rose-400 rounded-3xl">
              {/* <CalendarMain /> */}
              <AddTrainingForm handleCustomerCodeChangeInfo={handleCustomerCodeChangeInfo} selectedTab='forecast' selectedYear={selectedYearInfo} selectedDateRange={selectedDateRange} datesArray={datesArray} />
              {/* <CustomCalendar showTrainingForm={showTrainingForm}/> */}
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default Forecast;